'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'refrigerator';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e026';
var svgPathData = ['M48 96l0 64 192 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 48 0 0-64c0-26.5-21.5-48-48-48L96 48C69.5 48 48 69.5 48 96zm0 112l0 240c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-240-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-192 0z', 'M288 48c26.5 0 48 21.5 48 48l0 64-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-192 0 0-64c0-26.5 21.5-48 48-48l192 0zM240 208l0 120c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120 48 0 0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-240 192 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRefrigerator = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;